import { CapoPlugin } from "/home/aquarist/www/prod/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];